import {componentLoader, componentConfig} from "../../lib/component_initializer";
import {AvatarConfig, Avatar} from "./avatar"

export const avatarLoader = function (options = {}) {
    componentLoader(componentConfig(Avatar, AvatarConfig.componentTypeKey, AvatarConfig.baseHtmlClass), options);
};

